$(document).ready(function () {
    $('.accordion-trigger').on('click', function () {
        const $trigger = $(this);
        const isOpen = $trigger.hasClass('open');
        setAccordionTriggerState($trigger, !isOpen, true);
    });
});

function setAccordionTriggerState($trigger, shouldOpen, animate) {
    const target = $trigger.data('target');
    const icon = $trigger.find('.accordion-icon');
    const $target = $('#' + target);

    $trigger.toggleClass('open', shouldOpen);

    if ($target.length) {
        if (animate) {
            if (shouldOpen) {
                $target.stop(true, true).slideDown(200);
            } else {
                $target.stop(true, true).slideUp(200);
            }
        } else if (shouldOpen) {
            $target.show();
        } else {
            $target.hide();
        }
    }

    if (icon.length) {
        icon.toggleClass('open', shouldOpen);
    }
}

window.setAccordionTriggerState = setAccordionTriggerState;